// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__19UVN","requiredAsterisk":"Info_requiredAsterisk__2ZYAO"};